'use client';

import { createColumnHelper } from '@tanstack/table-core';
import clsx from 'clsx';
import React, {
  ReactElement, Suspense, useEffect, useMemo,useState
} from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Loader } from '@/components/loader/loader';
import { NativeTable } from '@/components/nativeTable/nativeTable';
import { useNativeTable } from '@/components/nativeTable/useNativeTable';
import { buildColumnClassString, ColumnModEnums } from '@/components/table/table';
import { Evaluation, Run } from '@/types/evals';
import { OutputFormatEnum, TimeFormatter, TimeSourceTypeEnum } from '@/utils/timeFormatter';

import styles from './page.module.scss';

export const dynamic = 'force-dynamic';

const columnHelper = createColumnHelper<Run>();
function EvaluationComparePage() {
  const [ evaluation, _setEvaluation ] = useState<Evaluation | undefined>();
  const [ isLoading, setIsLoading ] = useState<boolean>( true );
  const [ runs, _setRuns ] = useState<Run[]>( [] );

  /* HOOKS */
  useEffect( () => {
    _fetchData();
  }, [] );



  /* HELPERS */
  const _fetchData = async() => {
    // try {
    //   const runIdsArr = qRunIds.split( ',' );
    //   const evalRunsResultsRes: EvalRunsResultsGetRes = await APIGateway.evals.evalRunsResultsGet( qEvaluationId, runIdsArr, true, token );

    //   setEvaluation( evalRunsResultsRes.evaluation );
    //   setRuns( evalRunsResultsRes.runs );
    //   setResults( evalRunsResultsRes.results );
    // } catch( e ) {
    //   console.error( e );
    //   toast( 'unable to get evaluations' );
    // } finally {
    setIsLoading( false );
    // }
  };



  /* RENDERS */
  const renderInfo = (): ReactElement => (
    <>
      <span className={ clsx( styles.info_name ) }>
        <p>{ evaluation?.name }</p>
      </span>
      <span className={ clsx( styles.info_version ) }>
        <p>Runs</p>
      </span>
    </>
  );

  const renderDescription = (): ReactElement => (
    <span className={ styles.info_description }>{ evaluation?.description }</span>
  );

  const columns = useMemo( () => [
    columnHelper.display( {
      id: 'empty',
      header: '',
      size: 50,
      cell: () => '-',
      meta: {
        classStr: buildColumnClassString( { width: 5, styles: ColumnModEnums.CENTER } )
      }
    } ),
    columnHelper.display( {
      id: 'status',
      header: 'Status',
      size: 100,
      cell: () => '-',
      meta: {
        classStr: buildColumnClassString( { width: 10, styles: ColumnModEnums.NO_OVERFLOW } )
      }
    } ),
    columnHelper.accessor( 'id', {
      header: 'Run ID',
      size: 350,
      cell: info => info.getValue(),
      meta: {
        classStr: buildColumnClassString( { width: 35, styles: ColumnModEnums.NO_OVERFLOW } )
      }
    } ),
    columnHelper.accessor( 'createdBy', {
      header: 'Ran By',
      size: 150,
      cell: info => info.getValue() || '-',
      meta: {
        classStr: buildColumnClassString( { width: 15, styles: ColumnModEnums.NO_OVERFLOW } )
      }
    } ),
    columnHelper.accessor( 'createdAt', {
      header: 'Ran At (UTC)',
      size: 250,
      cell: info => (
        <TimeFormatter
          sourceType={ TimeSourceTypeEnum.ISO }
          value={ info.getValue() }
          outputFormat={ OutputFormatEnum.STRING_SINGLE }
        />
      ),
      meta: {
        classStr: buildColumnClassString( { width: 25, styles: ColumnModEnums.NO_OVERFLOW } )
      }
    } ),
    columnHelper.accessor( 'totalExamples', {
      header: '# Conversations',
      size: 100,
      cell: info => info.getValue() || '-',
      meta: {
        classStr: buildColumnClassString( { width: 10, styles: ColumnModEnums.CENTER } )
      }
    } )
  ], [] );

  const table = useNativeTable<Run>( {
    data: runs,
    columns,
    enableSorting: false
  } );

  const render = (): ReactElement => (
    <>
      <div className={ clsx( 'layout__row', styles.layout__info ) }>
        { renderInfo() }
      </div>
      <div className={ clsx( 'layout__row', 'pad', styles.layout__description ) }>
        { renderDescription() }
      </div>
      <div className={ styles.layout__runs }>
        <NativeTable table={ table } pagination="client" />
      </div>
    </>
  );

  return (
    <div className={ clsx( 'page' ) }>
      <ToastContainer />
      {
        isLoading
          ? <Loader />
          : render()
      }
    </div>
  );
}

export default function Page() {
  return (
    <Suspense fallback={ <Loader /> }>
      <EvaluationComparePage />
    </Suspense>
  );
}
